/**
 * File endpoint-redirect-track.js.
 * Track when endpoint requests result in page redirect
 */
 var redirectingFrom = window.location.href;
 
 function endpointRedirectTrack(referralToken, referralType, status, reason, redirectingTo) {
    const goToUrl = redirect(redirectingTo);
   
    let properties = {
      referral_token: referralToken,
      page_type: referralType,
      endpoint_response_code: status,
      redirect_reason: reason,
      redirecting_url: redirectingFrom,
      redirecting_to: redirectingTo
    };

    segment(
      'track',
      'Landing Page Visitor Redirected',
      properties,
      goToUrl
    );
 }
